import React from 'react';
import { reduxForm, Field } from 'redux-form';
import FormField from './FormField';
const normalizePhone = require('../../utils/normalizePhone').handler;

const required = value => value ? undefined : 'Required';


const containsEmail = (...props) => {
  const { email } = props[1] || {};
  return !email.includes('@') || !email.includes('.')
    ? 'Please provide a valide email address.'
    : undefined;
};

const EmailSMSForm = (
  {
    handleSubmit,
    smsTransactional,
    smsMarketingTW,
    postError,
    loading
  }
) => {
  return (
    <div>
      {postError &&
        <p className="loop-error">
          There was a problem with your submission, please try again.
        </p>}
      <form
        className="newsletterForm"
        name="Email-SMS-Form"
        onSubmit={handleSubmit}
        id="Email-SMS-Form"
      >
        <div className="form-row">
          <div className="col-12 col-sm-7">
            <Field
              name="email"
              type="text"
              component={FormField.Input}
              placeholder="Email Address"
              validate={[required, containsEmail]}
            />
          </div>
          {(!smsMarketingTW && !smsTransactional) && <div className="col-12 col-sm-7">
            <Field
              name="phoneNumber"
              placeholder="Mobile Phone (optional)"
              type="text"
              component={FormField.Input}
              normalizeOnBlur={normalizePhone()}
            />
          </div>}
        </div>
        <button type="submit" className="btn btn-primary" disabled={loading}>
          Subscribe
        </button>
      </form>
    </div>
  );
};

export default reduxForm({
  form: 'Email-SMS-Form'
})(EmailSMSForm);
